import {animate, style, transition, trigger} from "@angular/animations";

export const addressAnimations = [
    trigger(
        'inOutBoxAnimation',
        [
            transition(
                ':enter',
                [
                    style({ transform: 'translateY(-50%)', opacity: 0 }),
                    animate('0.3s ease-out',
                        style({ transform: 'translateY(0)', opacity: 1 }))
                ]
            ),
            transition(
                ':leave',
                [
                    style({ transform: 'translateY(0)', opacity: 1 }),
                    animate('0.3s ease-in',
                        style({ transform: 'translateY(-100%)', opacity: 0 }))
                ]
            )
        ]
    ),
    trigger(
        'inOutBackgroundAnimation',
        [
            transition(
                ':enter',
                [
                    style({ opacity: 0 }),
                    animate('0.3s ease-out',
                        style({ opacity: 1 }))
                ]
            ),
            transition(
                ':leave',
                [
                    style({ opacity: 1 }),
                    animate('0.3s ease-in',
                        style({ opacity: 0 }))
                ]
            )
        ]
    )
]
